export default __webpack_public_path__ + "media/Priva.537a932f.svg";